
import { mapState } from 'vuex';
import getLatLonMixin from '~/mixins/getLatLon';

export default {
    name: 'BusinessDetailsForm',
    mixins: [getLatLonMixin],
    props: {
        /**
         * The businesses existing logo when editing
         */
        existingLogo: {
            type: [Object, null],
            default: null,
        },
        form: {
            type: Object,
            required: true,
        },
        isEditForm: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState(['auth']),
        vatOptions() {
            return [
                { name: this.$t('jobs.vat.including'), slug: 'inc_vat' },
                { name: this.$t('jobs.vat.excluding'), slug: 'exc_vat' },
                { name: this.$t('jobs.vat.not_registered'), slug: 'not_registered' },
            ];
        },
        viableMobile() {
            if (this.form.contact_number_2.$model.slice(0, 2) === '07' || this.form.contact_number_2.$model.slice(0, 4) === '+447') {
                return this.form.contact_number_2.$model;
            }
            if (this.form.contact_number.$model.slice(0, 2) === '07' || this.form.contact_number.$model.slice(0, 4) === '+447') {
                return this.form.contact_number.$model;
            }
            return false;
        },
    },
    methods: {
        deleteImage(image) {
            /**
             * Delete image
             *
             * @type {object}
             */
            this.$emit('delete-image', image);
        },
        async submit() {
            if (!this.auth.loggedIn && this.viableMobile) {
                // eslint-disable-next-line no-underscore-dangle
                /* eslint vue/no-mutating-props: 0 */
                // @todo fix this
                this.form.mobile_number.$model = this.viableMobile;
            }
            [this.form.lat.$model, this.form.lon.$model] = await this.getLatLon({
                address_1: this.form.addressLine1.$model,
                address_2: this.form.addressLine2.$model,
                postcode: this.form.postcode.$model,
            });
            if (
                this.form.validateFields([
                    'business_name',
                    'addressLine1',
                    'addressLine2',
                    'postcode',
                    'contact_number',
                    'contact_number_2',
                    'description',
                    'lat',
                    'lon',
                    'url',
                    'vat',
                ])
            ) {
                this.$emit('submit');
            }
        },
    },
};
